import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class JFetAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVbrgss = 2.5;
		this.normIdssMin = 500;
		this.normIdssMax = 1.4;

		this.rankVbrgss = 0;
		this.rankIdssMin = 0;
		this.rankIdssMax = 0;

		this.weightVbrgss = 0.2;
		this.weightIdssMin = 0.15;
		this.weightIdssMax = 0.15;

		this.rV = 0;
		this.rImin = 0;
		this.rImax = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,part_Vbrgss,rV,rankVbrgss,part_Imin,rImin,rankIdssMin,part_Imac,rImax,rankIdssMax,feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);

		// ---------------------------------------------Breakdown voltage  V(BR)GSS Min (V)-----------------------------------------------------

		[this.rankVbrgss, this.rV] = this.calculateRankSingleSliderGTE(
			CIDS.BREAKDOWN_VOLTAGE_GSS,
			product,
			this.normVbrgss
		);

		// ---------------------------------------------Drain current  IDSS Min (mA)-----------------------------------------------------

		[this.rankIdssMin, this.rImin] = this.calculateRankSingleSliderGTE(
			CIDS.DRAIN_CURRENT_MIN,
			product,
			this.normIdssMin
		);

		// ---------------------------------------------Drain current  IDSS Max (mA)-----------------------------------------------------

		[this.rankIdssMax, this.rImax] = this.calculateRankSingleSliderLTE(
			CIDS.DRAIN_CURRENT_MAX,
			product,
			this.normIdssMax
		);

		// --------------------------------------------------------------------------------------------------------------

		let feRank =
			this.weightVbrgss * this.rankVbrgss +
			this.weightIdssMin * this.rankIdssMin +
			this.weightIdssMax * this.rankIdssMax;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightVbrgss - this.weightIdssMin - this.weightIdssMax) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
